import { Alert } from '@pmi/dsm-react';
import { AlertWarningSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import Overlay from '../../shared/components/Overlay';
import { AgreementApiModel } from '../../shared/models/DealModel';

import userAdminNavigate from '../../shared/hooks/userAdminNavigate';
import DealTab from '../../shared/components/DealTab';
import { useClearAlertMessages } from '../../shared/components/AlertGroup/useAccountAlerts';
import useGetDeals from '../../shared/hooks/useGetDeals';

export default function Invoices() {
  useClearAlertMessages();
  const {
    data: dealList,
    isLoading: isDealListLoading,
    isFetching: isDealListFetching,
    selectedHomeDeal,
    setSelectedHomeDeal,
  } = useGetDeals({ overviewOnly: true });

  const { navigate } = userAdminNavigate();

  const handleDealChange = (deal: AgreementApiModel) => {
    setSelectedHomeDeal(deal);
    navigate(`invoices/${deal.id}`);
  };

  const renderPrimaryContactMessage = () => {
    let note = '';

    if (
      selectedHomeDeal?.primaryContact?.firstName ||
      selectedHomeDeal?.primaryContact?.lastName
    ) {
      note = `${selectedHomeDeal?.primaryContact?.firstName} ${selectedHomeDeal?.primaryContact?.lastName}`;
    }

    if (selectedHomeDeal?.primaryContact?.phoneNumber) {
      note = `${
        note
          ? `${note} at ${selectedHomeDeal?.primaryContact?.phoneNumber}`
          : ` your administrator at ${selectedHomeDeal?.primaryContact?.phoneNumber}`
      }`;
    }

    if (selectedHomeDeal?.primaryContact?.email) {
      note = `${note} ${
        note && selectedHomeDeal?.primaryContact?.phoneNumber
          ? ` or ${selectedHomeDeal?.primaryContact?.email}`
          : ` at ${selectedHomeDeal?.primaryContact?.email}`
      }`;
    }

    if (!note) {
      note = ' your administrator';
    }

    return note;
  };

  return (
    <>
      {selectedHomeDeal && (
        <>
          {dealList.length > 1 && (
            <div className="mb-4">
              <DealTab
                onTabChange={handleDealChange}
                selectedDeal={selectedHomeDeal}
                deals={dealList}
              />
            </div>
          )}
          <div className="mb-4" data-testid="data-invoice">
            <Alert
              show
              icon={AlertWarningSolidIcon}
              alertText={`Invoice functionality is coming soon. Please contact ${renderPrimaryContactMessage()} for questions regarding payments.`}
              variant="warning"
            />
          </div>
        </>
      )}

      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isDealListLoading || isDealListFetching}
      />
    </>
  );
}
